import { cloneDeep, isEmpty } from 'lodash'

import { Services } from '@sigma-frontend-libs/commons'
import { PUBLIC_FIELDS_USER } from '@sigma-legacy-libs/essentials/lib/constants'

import { TEMPLATES_FILTER, fillDependence, generateServices, globalErrorHandler, permissionPresets, sendingsOutputFilter } from '@/utils'

import render from './render'

export default {
  name: 'TemplatesTemplate',

  mixins: [
    generateServices({
      name: Services.templates,

      async inputFilter(data) {
        if (!data.Owner) {
          await fillDependence.call(this, data, {
            service: 'users',
            permissions: [ 'reseller', true ],
            pathToId: 'OwnerId',
            pathToObject: 'Owner',
            outputPath: 'Owner',
            picks: PUBLIC_FIELDS_USER
          })
        }

        data.OwnerId = data.Owner && data.Owner.id || data.OwnerId

        return data
      },

      outputFilter: sendingsOutputFilter,

      find: {
        defaultFilter: cloneDeep(TEMPLATES_FILTER),
        defaultPagination: { limit: 10 }
      },
      get: false,
      create: false,
      update: {
        params: {
          query: {
            $scope: [ 'full' ]
          }
        }
      },
      remove: {
        redirect: false
      }
    })
  ],

  data() {
    return {
      filter: cloneDeep(TEMPLATES_FILTER)
    }
  },

  computed: {
    canUpdateTemplatesAsMeUp() {
      return this.checkPermissions(`advanced.${Services.templates}.update`, permissionPresets.meUp)
    },

    canRemoveTemplatesAsMeUp() {
      return this.checkPermissions(`advanced.${Services.templates}.remove`, permissionPresets.meUp)
    }
  },

  watch: {
    filter: {
      handler() {
        this.restData[Services.templates].find.filter = cloneDeep(this.filter)
      },
      deep: true
    }
  },

  mounted() {
    if (!isEmpty(this.$route.params)) {
      this.restData[Services.templates].find.filter.id = this.$route.params.id
    } else {
      this.rest[Services.templates].find()
    }
  },

  methods: {
    applyHandler(value) {
      this.$emit('apply', value)
    },

    async updateHandler(value) {
      if (this.canUpdateTemplatesAsMeUp) {
        try {
          const response = await this.rest[Services.templates].update(value.id, value)
          if (response) {
            const items = this.restData[Services.templates].find.data
            const index = items.findIndex(item => {
              return item.id === response.id
            })
            if (index !== -1) {
              items.splice(index, 1, response)
            }
          }
        } catch (error) {
          globalErrorHandler(error)
        }
      }
    },

    async removeHandler(id) {
      if (this.canRemoveTemplatesAsMeUp) {
        try {
          await this.rest[Services.templates].remove(id)
        } catch (error) {
          globalErrorHandler(error)
        }
      }
    }
  },

  render
}
